import { render } from "./XiamanLogo.vue?vue&type=template&id=50d44e4d"
import script from "./XiamanLogo.vue?vue&type=script&lang=js"
export * from "./XiamanLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__